import { ApiJob, ApiProject } from "@incendium/api";
import { jobService } from "Apis";
import { useProjectSharedState } from "./useSharedState";

const fetchJobs = async (project: ApiProject) => {
  const jobs = await jobService.jobServiceListJobs({
    projectId: project.id as number,
  });
  return jobs.results || [];
};

export const useJobs = () => {
  const { state, setState, refetch } = useProjectSharedState<ApiJob[]>(
    "jobs",
    [],
    fetchJobs
  );

  return {
    jobs: state,
    setJobs: setState,
    refetchJobs: refetch,
  };
};
